class WotobeusCouple extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.form = this.closest('form');
    this.parts = [...this.querySelectorAll('[data-couple-part]')];
    for (const part of this.parts) {
      const brand = part.querySelector('[data-couple-brand]');
      const model = part.querySelector('[data-couple-model]');
      const placeholder = model.options[0].textContent;
      const options = [...model.querySelectorAll('option[data-brand]')].map(o => ({value:o.value, brand:o.dataset.brand, text:o.textContent}));
      const update = () => {
        const previous = model.value;
        model.replaceChildren(new Option(placeholder, ''));
        for (const option of options.filter(o => o.brand === brand.value)) model.add(new Option(option.text, option.value));
        model.disabled = !brand.value;
        if (options.some(o => o.brand === brand.value && o.value === previous)) model.value = previous;
        this.querySelector('[data-couple-error]').hidden = true;
      };
      brand.addEventListener('change', update, {signal:this.controller.signal});
      model.addEventListener('change', () => { model.setCustomValidity(''); this.querySelector('[data-couple-error]').hidden = true; }, {signal:this.controller.signal});
      update();
    }
    this.form?.addEventListener('submit', event => {
      if (!this.validate()) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, {capture:true, signal:this.controller.signal});
  }
  disconnectedCallback() { this.controller?.abort(); }
  validate() {
    let invalid;
    for (const part of this.parts) {
      const brand = part.querySelector('[data-couple-brand]');
      const model = part.querySelector('[data-couple-model]');
      if (!brand.value || !model.value || model.selectedOptions[0]?.dataset?.brand && model.selectedOptions[0].dataset.brand !== brand.value) invalid ||= !brand.value ? brand : model;
    }
    this.querySelector('[data-couple-error]').hidden = !invalid;
    if (invalid) { invalid.focus(); this.form?.reportValidity(); return false; }
    return true;
  }
}
if (!customElements.get('wotobeus-couple')) customElements.define('wotobeus-couple', WotobeusCouple);
